module.exports = __webpack_public_path__ + "static/img/github.39589f0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/github.jpeg
// module id = 27
// module chunks = 2